/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTopTradersByPnLOptions,
  GetTopTradersByPnLStatus200,
  GetTopTradersByPnLStatus400,
  GetTopTradersByPnLStatus401,
  GetTopTradersByPnLStatus403,
  GetTopTradersByPnLStatus500,
} from '../types/GetTopTradersByPnL'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTopTradersByPnL } from '../clients/getTopTradersByPnL'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTopTradersByPnLQueryKey = ({ query }: Omit<GetTopTradersByPnLOptions, 'headers'>) =>
  [{ url: '/v1/user/ranking' }, ...(query ? [query] : [])] as const

type GetTopTradersByPnLQueryKey = ReturnType<typeof getTopTradersByPnLQueryKey>

export function getTopTradersByPnLQueryOptions(
  { query }: GetTopTradersByPnLOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTopTradersByPnLQueryKey({ query })
  return queryOptions<
    GetTopTradersByPnLStatus200,
    ResponseErrorConfig<
      | GetTopTradersByPnLStatus400
      | GetTopTradersByPnLStatus401
      | GetTopTradersByPnLStatus403
      | GetTopTradersByPnLStatus500
    >,
    GetTopTradersByPnLStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTopTradersByPnL({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Returns user PnL ranking for the provided time range. By default only users with allow_copy_trading=true are included. Set all=true to include all users; this requires an admin role.
 * @summary Get top traders by PnL
 * {@link /v1/user/ranking}
 */
export function useGetTopTradersByPnL<
  TData = GetTopTradersByPnLStatus200,
  TQueryData = GetTopTradersByPnLStatus200,
  TQueryKey extends QueryKey = GetTopTradersByPnLQueryKey,
>(
  {
    query,
  }: { query: GetTopTradersByPnLOptions['query'] | (() => GetTopTradersByPnLOptions['query']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTopTradersByPnLStatus200,
        ResponseErrorConfig<
          | GetTopTradersByPnLStatus400
          | GetTopTradersByPnLStatus401
          | GetTopTradersByPnLStatus403
          | GetTopTradersByPnLStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getTopTradersByPnLQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTopTradersByPnLQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTopTradersByPnLStatus400
      | GetTopTradersByPnLStatus401
      | GetTopTradersByPnLStatus403
      | GetTopTradersByPnLStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
